/* @generated from adl module InfoRequest */

import * as ADL from './runtime/adl';
import * as Path from './Path';
import * as SrcLoc from './SrcLoc';

export type InfoRequestId = number;

const InfoRequestId_AST : ADL.ScopedDecl =
  {"moduleName":"InfoRequest","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}},"name":"InfoRequestId","version":{"kind":"nothing"}}};

export const snInfoRequestId: ADL.ScopedName = {moduleName:"InfoRequest", name:"InfoRequestId"};

export function texprInfoRequestId(): ADL.ATypeExpr<InfoRequestId> {
  return {value : {typeRef : {kind: "reference", value : snInfoRequestId}, parameters : []}};
}

export interface InfoRequest {
  filePath: Path.PathRelFile;
  location: SrcLoc.LineCol;
}

export function makeInfoRequest(
  input: {
    filePath: Path.PathRelFile,
    location: SrcLoc.LineCol,
  }
): InfoRequest {
  return {
    filePath: input.filePath,
    location: input.location,
  };
}

const InfoRequest_AST : ADL.ScopedDecl =
  {"moduleName":"InfoRequest","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}},{"annotations":[],"serializedName":"location","default":{"kind":"nothing"},"name":"location","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineCol"}},"parameters":[]}}]}},"name":"InfoRequest","version":{"kind":"nothing"}}};

export const snInfoRequest: ADL.ScopedName = {moduleName:"InfoRequest", name:"InfoRequest"};

export function texprInfoRequest(): ADL.ATypeExpr<InfoRequest> {
  return {value : {typeRef : {kind: "reference", value : snInfoRequest}, parameters : []}};
}

export interface InfoRequestResult {
  typeInfoSpans: TypeInfo[];
}

export function makeInfoRequestResult(
  input: {
    typeInfoSpans: TypeInfo[],
  }
): InfoRequestResult {
  return {
    typeInfoSpans: input.typeInfoSpans,
  };
}

const InfoRequestResult_AST : ADL.ScopedDecl =
  {"moduleName":"InfoRequest","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"typeInfoSpans","default":{"kind":"nothing"},"name":"typeInfoSpans","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"TypeInfo"}},"parameters":[]}]}}]}},"name":"InfoRequestResult","version":{"kind":"nothing"}}};

export const snInfoRequestResult: ADL.ScopedName = {moduleName:"InfoRequest", name:"InfoRequestResult"};

export function texprInfoRequestResult(): ADL.ATypeExpr<InfoRequestResult> {
  return {value : {typeRef : {kind: "reference", value : snInfoRequestResult}, parameters : []}};
}

export interface TypeInfo {
  span: SrcLoc.LineColRange;
  typeString: string;
}

export function makeTypeInfo(
  input: {
    span: SrcLoc.LineColRange,
    typeString: string,
  }
): TypeInfo {
  return {
    span: input.span,
    typeString: input.typeString,
  };
}

const TypeInfo_AST : ADL.ScopedDecl =
  {"moduleName":"InfoRequest","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"span","default":{"kind":"nothing"},"name":"span","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"LineColRange"}},"parameters":[]}},{"annotations":[],"serializedName":"typeString","default":{"kind":"nothing"},"name":"typeString","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"TypeInfo","version":{"kind":"nothing"}}};

export const snTypeInfo: ADL.ScopedName = {moduleName:"InfoRequest", name:"TypeInfo"};

export function texprTypeInfo(): ADL.ATypeExpr<TypeInfo> {
  return {value : {typeRef : {kind: "reference", value : snTypeInfo}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "InfoRequest.InfoRequestId" : InfoRequestId_AST,
  "InfoRequest.InfoRequest" : InfoRequest_AST,
  "InfoRequest.InfoRequestResult" : InfoRequestResult_AST,
  "InfoRequest.TypeInfo" : TypeInfo_AST
};
